import { PipeTransform } from '@angular/core';
/*
 * Takes bytes and make it more human readable.
 * Usage:
 *   value | readableBytes:precision
 * Example:
 *   {{ 6087302 |  readableBytes:1}}
 *   formats to: 5.8 MB
*/
var BytesReadablePipe = /** @class */ (function () {
    function BytesReadablePipe() {
    }
    /**
     * Transforms bytes to human readable format
     * @param {any} bytes
     * @param {any} precision
     * @returns {string}
     */
    BytesReadablePipe.prototype.transform = function (bytes, precision) {
        if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
            return '-';
        }
        if (typeof precision === 'undefined') {
            precision = 1;
        }
        var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'], number = Math.floor(Math.log(bytes) / Math.log(1024));
        return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
    };
    return BytesReadablePipe;
}());
export { BytesReadablePipe };
